import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/time.svg` */
export const TimeIcon = createTripletGlyphIcon('TimeIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.00391 3.95801C8.30749 3.95821 8.55371 4.20418 8.55371 4.50781V8.37207C8.55387 8.40863 8.57131 8.44389 8.60059 8.46582L10.7891 10.1045C11.0317 10.2865 11.082 10.631 10.9004 10.874C10.7185 11.1168 10.373 11.1668 10.1299 10.9854L7.94141 9.34668C7.63469 9.11705 7.45426 8.7552 7.4541 8.37207V4.50781C7.4541 4.20406 7.70015 3.95801 8.00391 3.95801Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00098 1.33301C11.6821 1.3334 14.6668 4.31884 14.667 8C14.6668 11.6812 11.6821 14.6656 8.00098 14.666C4.31971 14.6658 1.33422 11.6813 1.33398 8C1.3342 4.31873 4.3197 1.33322 8.00098 1.33301ZM8.00098 2.33105C4.8704 2.33126 2.33225 4.86943 2.33203 8C2.33226 11.1306 4.87041 13.6687 8.00098 13.6689C11.1314 13.6685 13.6697 11.1304 13.6699 8C13.6697 4.86954 11.1314 2.33145 8.00098 2.33105Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.93066 4.04688C9.23435 4.04691 9.4804 4.293 9.48047 4.59668V8.94434C9.48056 9.00705 9.51046 9.06677 9.56055 9.10449L12.0234 10.9482C12.266 11.1304 12.3156 11.4748 12.1338 11.7178C11.9517 11.9606 11.6063 12.0099 11.3633 11.8281L8.90137 9.98535C8.57378 9.73993 8.38095 9.35366 8.38086 8.94434V4.59668C8.38093 4.29312 8.62715 4.04711 8.93066 4.04688Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.00098 1.51172C13.1365 1.51198 16.4891 4.86449 16.4893 9C16.4891 13.1355 13.1364 16.488 9.00098 16.4883C4.86539 16.4881 1.51185 13.1356 1.51172 9C1.51184 4.86441 4.86539 1.51185 9.00098 1.51172ZM9.00098 2.61133C5.4729 2.61146 2.61242 5.47192 2.6123 9C2.61244 12.5281 5.47291 15.3885 9.00098 15.3887C12.5289 15.3884 15.3895 12.528 15.3896 9C15.3895 5.472 12.5289 2.61159 9.00098 2.61133Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.0059 6.01172C12.4198 6.01203 12.7559 6.3477 12.7559 6.76172V12.5586C12.7561 12.637 12.7936 12.7118 12.8564 12.7588L16.1387 15.2168C16.4696 15.4652 16.5381 15.9353 16.29 16.2666C16.0419 16.5977 15.5717 16.6645 15.2402 16.417L11.957 13.959C11.516 13.6287 11.2561 13.1095 11.2559 12.5586V6.76172C11.2559 6.34751 11.5916 6.01172 12.0059 6.01172Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.001 2.00098C17.5231 2.00116 21.9998 6.47788 22 12C21.9998 17.5221 17.5231 21.9988 12.001 21.999C6.47886 21.9988 2.00213 17.5221 2.00195 12C2.00213 6.47788 6.47886 2.00116 12.001 2.00098ZM12.001 3.49707C7.30491 3.49725 3.49823 7.30393 3.49805 12C3.49823 16.6961 7.30491 20.5037 12.001 20.5039C16.697 20.5037 20.5047 16.6961 20.5049 12C20.5047 7.30393 16.697 3.49725 12.001 3.49707Z"
        fill="currentColor"
      />
    </svg>
  ),
});
